import { render } from "./WhatDo.vue?vue&type=template&id=b70fa8f0&scoped=true"
import script from "./WhatDo.vue?vue&type=script&lang=js"
export * from "./WhatDo.vue?vue&type=script&lang=js"

import "./WhatDo.vue?vue&type=style&index=0&id=b70fa8f0&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70fa8f0"]])

export default __exports__